module.exports = __webpack_public_path__ + "static/media/admin-Icons-phone.773e77f0.svg";